// Cliente para el Worker de Cloudflare que sirve la key universal.
// Configura la URL real en el .env del frontend:
//   REACT_APP_KEY_API_BASE=https://minirick-key-worker.TU-SUBDOMINIO.workers.dev
const API_BASE = process.env.REACT_APP_KEY_API_BASE || "";

// /api/key exige un token de acceso — se pide aquí, y solo el
// frontend lo llama (y solo cuando el gate del navegador da luz
// verde). Así /api/key no queda abierto a cualquiera que se guarde
// la URL directa.
export async function startAccess() {
  const res = await fetch(`${API_BASE}/api/access/start`, { method: "POST" });
  if (!res.ok) throw new Error("no se pudo obtener acceso");
  return res.json(); // { token, expiresInSeconds }
}

export async function fetchKeyState(accessToken) {
  const res = await fetch(`${API_BASE}/api/key?access=${encodeURIComponent(accessToken)}`);
  if (!res.ok) throw new Error("no se pudo obtener la key");
  return res.json();
}

export async function validateKey(key) {
  const res = await fetch(`${API_BASE}/api/validate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key }),
  });
  const data = await res.json().catch(() => ({ valid: false }));
  return { ...data, ok: res.ok };
}
